module.exports = {
  "version": "0.24.0"
};


//////////////////
// WEBPACK FOOTER
// /root/social-native/socialnative-web/node_modules/axios/lib/env/data.js
// module id = 857
// module chunks = 69